import styled from 'styled-components';
import { getColor } from '../../../../../utils';

export const Wrapper = styled.div`
  margin-bottom: 20px;
`;

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

export const ButtonWrapper = styled.div`
  width: min-content;
  margin: 8px 0;
  padding: 5px;
  border-radius: 3px;
  cursor: pointer;

  font-weight: ${props => (props.selected ? 600 : 400)};
  border: 1px solid
    ${props => (props.selected ? `#cccccc` : 'rgba(0, 0, 0, 0)')};
  ${props =>
    props.selected && 'box-shadow: -3px 3px 5px 6px rgba(100, 100, 100, 0.1);'}
  ${props =>
    props.selected &&
    `color: ${getColor(props.theme, 'primary', 5)};`}

  transition: all 0.3s;

  &:hover {
    font-weight: 600;
  }

  & > div:nth-child(1) {
    height: 60px;
    width: 60px;
    border-radius: 2px;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
    }
  }

  & > div:nth-child(2) {
    text-align: center;
    padding-top: 8px;
    font-size: 12px;
  }
`;
